module.exports = __webpack_public_path__ + "static/media/di308kz.db520fda.pdf";